<template>
  <div>
    <h3 class="text-white text-lg font-semibold mb-4">{{ tx.contato }}</h3>
    <ul class="space-y-3">
      <li class="flex items-center">
        <Mail class="h-5 w-5 mr-2" />
        <a 
          href="mailto:ola@autovolt.ai"
          class="hover:text-white transition-colors"
        >
          ola@autovolt.ai
        </a>
      </li>
      <li class="flex items-center">
        <Phone class="h-5 w-5 mr-2" />
        <a 
          v-if="!isLoading"
          :href="ctaWhatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="hover:text-white transition-colors"
        >
          {{ formattedPhoneNumber }}
        </a>
        <span v-else class="text-gray-400">{{ tx.carregando }}</span>
      </li>
      <li class="flex items-center">
        <MapPin class="h-5 w-5 mr-2" />
        Camboriú, SC
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import config from '@/config'
import axios from 'axios';
import { Mail, Phone, MapPin } from 'lucide-vue-next'
import { computed, onMounted, ref } from 'vue';
import { useTextos } from '../../i18n/idioma'

const tx = useTextos({
  pt: { contato: 'Contato', carregando: 'Carregando...' },
  en: { contato: 'Contact', carregando: 'Loading...' },
  es: { contato: 'Contacto', carregando: 'Cargando...' },
})

const error = ref(false);
const isLoading = ref(true);
const phoneNumber = ref('');
const ctaWhatsappUrl = ref('#')

var message = encodeURIComponent('Olá, gostaria de informações sobre o atendimento com IA')

const formattedPhoneNumber = computed(() => {
  const raw = phoneNumber.value.replace(/\D/g, '');

  if (raw.length === 13) {
    // ex: 5547988489706
    return `+${raw.slice(0, 2)} ${raw.slice(2, 4)} ${raw.slice(4, 9)}-${raw.slice(9)}`;
  } else if (raw.length === 11) {
    // ex: 47988489706
    return `+55 ${raw.slice(0, 2)} ${raw.slice(2, 7)}-${raw.slice(7)}`;
  }

  return phoneNumber.value;
});

const fetchConfigs = async () => {
  try {
    const response = await axios.get(`${config.API_URL}/api/configuracoes`)
    const data = response.data.configuracoes;

    phoneNumber.value = data.telefone;
    ctaWhatsappUrl.value = `https://wa.me/${phoneNumber.value}?text=${message}`;
  } catch (err) {
    console.error(err);
    error.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(fetchConfigs);
</script>